import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/liveHall',
      name: 'liveHall',
      component: () => import ('@/client/liveHall/liveHall.vue')
    },
    {
      path: '/',
      name: 'login',
      component: () => import ('@/client/login/login.vue')
    },
    {
      path: '/liveRoom/:id',
      name: 'liveRoom',
      component: () => import ('@/client/liveRoom/liveRoom.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js